import React from 'react'

import { FaCalendarAlt, FaPen, FaUser, FaUserCircle, FaFileDownload } from "react-icons/fa"
import { FaFileUpload } from "react-icons/fa"
import { FaBinoculars } from "react-icons/fa"
import { FaCoffee } from "react-icons/fa"
import { FaBook } from "react-icons/fa"
import { AiFillSetting } from "react-icons/ai"

import { Link } from 'react-router-dom'
import styles from "./AdminMenu.module.css"

import { downloadCVs } from '../../../utils/apiCalls'

import  download  from 'downloadjs'

import {Toaster, toast} from "react-hot-toast"

function AdminMenu({ showMenu,setShowMenu }) {
     async function handleDownloadCVs(){
        toast("Se pregătește descărcarea. Acest proces poate dura câteva minute");
            const fileBlob = await downloadCVs();
            download(fileBlob, "CVs.zip", "application/zip");
            toast("CV-urile au fost descărcate");
        }
  return (
    <>
    <div className={`${styles.menuContainer} ${showMenu ? styles.showMenu : ''}`}>
            <Link to="/admin" style={{ textDecoration: 'none', color: "white" }}>
                <div onClick={() => setShowMenu(false)} className={styles.inlineItem}>
                    <FaUserCircle />
                    <p>Utilizatori înscriși</p>
                </div>
            </Link>

            <Link to="/admin/view-booked" style={{ textDecoration: 'none', color: "white" }}>
                <div onClick={() => setShowMenu(false)} className={styles.inlineItem}>
                    <FaCalendarAlt />
                    <p>Interviuri programate</p>
                </div>
            </Link>

            <Link to="/admin/create-interview" style={{ textDecoration: 'none', color: "white" }}>
                <div onClick={() => setShowMenu(false)} className={styles.inlineItem}>
                    <FaPen />
                    <p>Creează / modifică interviu</p>
                </div>
            </Link>

            {/* <Link to='/admin/?view=feedback' style={{ textDecoration: 'none', color: "black" }}> */}
               <button onClick={() => {handleDownloadCVs(); setShowMenu(false)}} className={`${styles.navItem} ${styles.inlineItem}`}>
                                               <FaFileDownload className={styles.icon2}/>
                                               Descarcă CV-urile participanților
                                           </button>
            {/* </Link> */}
    </div>
    <Toaster/>
    </>
  )
}

export default AdminMenu